import React from "react";
import Main from "../components/layout/Main";
import ProtectedRoute from "../components/comps/protected_route";
import LmsDashboard from "../pages/lms/LmsDashboard";
import LmsSessions from "../pages/lms/LmsSessions";
import LmsContent from "../pages/lms/LmsContent";
import LmsUploadLogs from "../pages/lms/LmsUploadLogs";
import LmsQuizzes from "../pages/lms/LmsQuizzes";
import LmsReports from "../pages/lms/LmsReports";
import LmsLiveSessions from "../pages/lms/LmsLiveSessions";

const lmsRoutes = [
  {
    path: "/admin",
    element: (
      <ProtectedRoute>
        <Main />
      </ProtectedRoute>
    ),
    children: [
      {
        path: "lms/dashboard",
        element: (
          <ProtectedRoute>
            <LmsDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "lms/sessions",
        element: (
          <ProtectedRoute>
            <LmsSessions />
          </ProtectedRoute>
        ),
      },
      {
        path: "lms/content",
        element: (
          <ProtectedRoute>
            <LmsContent />
          </ProtectedRoute>
        ),
      },
      {
        path: "lms/content-upload-log",
        element: (
          <ProtectedRoute>
            <LmsUploadLogs />
          </ProtectedRoute>
        ),
      },
      {
        path: "lms/quizzes",
        element: (
          <ProtectedRoute>
            <LmsQuizzes />
          </ProtectedRoute>
        ),
      },
      {
        path: "lms/live-sessions",
        element: (
          <ProtectedRoute>
            <LmsLiveSessions />
          </ProtectedRoute>
        ),
      },
      {
        path: "lms/weekly-reports",
        element: (
          <ProtectedRoute>
            <LmsReports />
          </ProtectedRoute>
        ),
      },
    ],
  },
];

export default lmsRoutes;
